/**
 * FERP PDF Right Panel (DRR-079)
 *
 * Tab container for: Annotations | Comments | Document Trail
 */

import { Tabs, Text } from '@mantine/core';
import { IconNotes, IconMessageCircle, IconRoute } from '@tabler/icons-react';
import { usePdfSuite } from './PdfSuiteContext';
import { PdfAnnotationListPanel } from './PdfAnnotationListPanel';
import { CommentThread } from './CommentThread';
import { DocumentTrailPanel } from './DocumentTrailPanel';
import type { RightPanelTab } from './types';

export function PdfRightPanel() {
  const { state, dispatch } = usePdfSuite();
  const activeTab = state.rightPanel ?? 'annotations';

  return (
    <Tabs
      value={activeTab}
      onChange={(tab) => dispatch({ type: 'SET_RIGHT_PANEL', tab: tab as RightPanelTab })}
      variant="outline"
      style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
    >
      <Tabs.List grow>
        <Tabs.Tab value="annotations" leftSection={<IconNotes size={14} />}>
          <Text size="xs">Annotations</Text>
        </Tabs.Tab>
        <Tabs.Tab value="comments" leftSection={<IconMessageCircle size={14} />}>
          <Text size="xs">Comments</Text>
        </Tabs.Tab>
        <Tabs.Tab value="trail" leftSection={<IconRoute size={14} />}>
          <Text size="xs">Trail</Text>
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="annotations" style={{ flex: 1, overflow: 'auto' }}>
        <PdfAnnotationListPanel />
      </Tabs.Panel>
      <Tabs.Panel value="comments" style={{ flex: 1, overflow: 'auto' }}>
        <CommentThread />
      </Tabs.Panel>
      <Tabs.Panel value="trail" style={{ flex: 1, overflow: 'auto' }}>
        <DocumentTrailPanel />
      </Tabs.Panel>
    </Tabs>
  );
}
